import styled, { CSSObject } from 'styled-components';

export const Container = styled.div<{ gap: number; styles?: CSSObject }>`
    display: flex;
    flex-direction: row;
    gap: ${({ gap }) => gap}px;
    overflow-y: auto;
    padding-bottom: 48px;
    cursor: grab;
    &::-webkit-scrollbar {
        width: 8px;
        height: 8px;
    }

    &::-webkit-scrollbar-corner,
    &::-webkit-scrollbar-button,
    &::-webkit-scrollbar-track-piece {
        display: none;
    }

    &::-webkit-scrollbar-track {
        background: #1e1e1e;
    }

    &::-webkit-scrollbar-thumb {
        background: #bbff33;
        border-radius: 6px;
    }
    ${({ styles }) => styles}
`;
